
export default {
    name: "skeleton-jd-item"
}
